import "stylesheets/portal/shop_top_smart_phone"
